import React from 'react';
import { FINANCIAL_EFFECTS, INCLUDE_IN_GROUPS } from '../../adapters';

const TotalsEffectTab = ({ field, readOnly, onChange }) => {
  const cfg = field.metadata?.businessConfig || {};
  const patchCfg = (patch) => onChange({
    metadata: {
      ...(field.metadata || {}),
      businessConfig: { ...cfg, ...patch },
    },
  });

  return (
    <div className="ra-tpl-tab-body">
      <div className="form-group">
        <label>Effect on Bill</label>
        <select
          disabled={readOnly}
          value={cfg.financialEffect || 'INFORMATION'}
          onChange={(e) => patchCfg({ financialEffect: e.target.value })}
        >
          {FINANCIAL_EFFECTS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>
      <div className="form-group">
        <label>Include In</label>
        <select
          disabled={readOnly}
          value={cfg.includeInGroup || 'NONE'}
          onChange={(e) => patchCfg({ includeInGroup: e.target.value })}
        >
          {INCLUDE_IN_GROUPS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <p className="ra-tpl-help">Select which RA Bill total this field contributes to. Auto-total fields rebuild their sum on save.</p>
      </div>
    </div>
  );
};

export default TotalsEffectTab;
